import React from 'react';
import { thankyouIntentOOI as ThankyouIntentOOI } from '@wix/pro-gallery-artstore-statics';

export default (props: any) => {
  return <ThankyouIntentOOI {...props} />;
};
